import {Component, Input, OnInit, computed, model, signal} from '@angular/core';
import {ApiService} from '../../../../api/service/api.service';
import {ChatListItemModel} from '../../../../api/model/chat.model';
import {TjKeycloakService} from '../../../../core/services';
import {TicketTechnician} from '../../../../api/model/TicketTechnicians.model';

export enum ChatType {
  ADMIN_TECHNICIAN = 0,
  ADMIN_PARTNER = 1,
  ADMIN_ADMIN = 2,
  ADMIN_CUSTOMER = 3,
}

@Component({
  selector: 'tj-ticket-chats',
  templateUrl: './ticket-chats.component.html',
  styleUrls: ['./ticket-chats.component.scss'],
})
export class TicketChatsComponent implements OnInit {
  @Input() ticketId: number;
  @Input() technicians: TicketTechnician[];
  @Input() partnerId: number;

  chats = signal<ChatListItemModel[]>([]);
  activeTabIndex = model<number>(0);

  roleMap = {
    ADMIN_TECHNICIAN: 'TICKET_COMMENT_TECHNICIAN',
    ADMIN_ADMIN: 'TICKET_COMMENT_ADMIN',
    ADMIN_PARTNER: 'TICKET_COMMENT_PARTNER',
    ADMIN_CUSTOMER: 'TICKET_COMMENT_CUSTOMER',
  };

  titleMap = {
    ADMIN_ADMIN: 'Admin',
    ADMIN_TECHNICIAN: 'Technician',
    ADMIN_PARTNER: 'Account',
    ADMIN_CUSTOMER: 'Customer',
  };

  visibleChats = computed(() =>
    this.chats().filter(
      chat => this.canAccessChat(chat.chatType) && this.checkForPartner(chat.chatType)
    )
  );

  constructor(
    private api: ApiService,
    private keycloakService: TjKeycloakService,
  ) {}

  ngOnInit() {
    this.api.chat.findChats(this.ticketId).subscribe((chats: ChatListItemModel[]) => {
      const sorted = this.sortChats(chats);
      this.chats.set(sorted);

      const visible = this.visibleChats();
      let latestTimestamp: string | null = null;
      let latestChatIndex = 0;

      for (let i = 0; i < visible.length; i++) {
        const chat = visible[i];
        for (const comment of chat.comments) {
          if (!latestTimestamp || new Date(comment.createdAt) > new Date(latestTimestamp)) {
            latestTimestamp = comment.createdAt;
            latestChatIndex = i;
          }
        }
      }

      visible.forEach(chat => {
        chat.commentsCount = chat.comments.length;
        chat.hasLatestComment = chat.comments.some(
          comment => comment.createdAt === latestTimestamp
        );
      });

      this.activeTabIndex.set(latestChatIndex);
    });
  }

  sortChats(chats: ChatListItemModel[]): ChatListItemModel[] {
    return chats.sort((a, b) => ChatType[a.chatType] - ChatType[b.chatType]);
  }

  canAccessChat(chatType: string): boolean {
    const role = this.roleMap[chatType];
    return this.keycloakService.hasRole(role);
  }

  checkForPartner(chatType: string): boolean {
    if (chatType !== 'ADMIN_PARTNER') {
      return true;
    }
    return this.partnerId !== null;
  }
}
